/*
https://okgithub.office.okcupid.com/OkCupid/okcupid/blob/master/cupid/docs/specs/billing-api/BillingWS.md#errors
*/

export default function getApiErrorType(code) {
	switch (Math.abs(code)) {
		case 122: // Unknown platform
		case 1502: // at least one or more fields are empty for CC params
		case 401: // at least one or more fields are empty for PPL params (paypal/init)
		case 403: // at least one or more fields are empty for PPL params (paypal/purchase)
		case 102: // Technical error while checking the parameters
		case 119: // Technical error while checking the parameters
		case 103: // Technical error while checking the parameters
		case 1503: // Technical error while checking fraud status (only for CC purchase)
		case 1601: // Technical error while checking fraud status (only for CC purchase)
		case 1704: // Technical error while checking fraud status (only for CC purchase)
		case 1603: // Technical error while checking fraud status (only for CC purchase)
		case 1605: // Technical error while checking fraud status (only for CC purchase)
		case 111: // Technical error while trying to get uber
			return "error";

		default:
			return "failure";
	}
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/getApiErrorType.js